import { axios } from './axios';

export const getPostCheckoutSurveyOptions = async () => {
  const response = await axios.get('/post_checkout_survey_options');
  return response.data;
};
